<script setup lang="ts">
import { Dialog, Button } from 'primevue';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../store/authStore';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

const authStore = useAuthStore();
const visible = computed(() => !authStore.isAuthenticated);
const router = useRouter();

function onLoginClick() {
  router.push({ name: 'login'});
}

</script>

<template>
  <Dialog :header="translations.auth.loggedOut.title"
    :visible="visible"
    position="bottom"
    :modal="false"
    :draggable="false"
    :closable="false">

    <p>{{ translations.auth.loggedOut.description }}</p>

    <template #footer>
      <Button :label="translations.generic.login" @click="onLoginClick"></Button>
    </template>
  </Dialog>
</template>
